/** @jsx jsx */

import { Fragment as _, useRef, useEffect } from 'react';
import { keyframes } from 'emotion';
import { css, jsx } from '@emotion/core';
import { connect } from 'react-redux';
import EditMarker from 'components/UI/EditMarker';
import { colors } from 'styles/variables';
import getBlockById from 'services/apiHelpers/getBlockById';
import setCurrentBlock from 'services/apiHelpers/setCurrentBlock';
import { EditWrapper0, EditWrapper1 } from './EditWrappers';
import svgPlaceholder from 'assets/animations/placeholder.js';
import isIE from 'services/isIE';

import ReactBodymovin from 'react-lottie';

const { lPink } = colors;

const SVG = ({ id, focusedNodeId, src, editWrapperType = 0 }) => {
  let animationData;
  // this : src != undefined seemed to break it ?
  if (src) {
    try {
      animationData = JSON.parse(src);
    } catch {
      animationData = svgPlaceholder;
    }
  } else {
    animationData = svgPlaceholder;
  }

  const selected = focusedNodeId === id;

  const svg = useRef<HTMLSpanElement>(null);
  const reactBodyMovin = useRef<any>(null);

  const bodymovinOptions = {
    loop: true,
    autoplay: true,
    prerender: true,
    renderer: 'svg',
    animationData,
  };

  const hasAnimationData = Object.keys(animationData).length > 0;

  useEffect(() => {
    if (!isIE()) return;
    if (!svg.current) return;

    const svg_ = svg.current.querySelector('svg')!;

    if (!svg_) {
      return;
    }

    svg_.removeAttribute('width');
    svg_.removeAttribute('height');

    const onResize = () => {
      svg_.style.width = '100%';
      svg_.style.height = `${window.innerHeight / 2}px`;
    };
    onResize();
    window.addEventListener('resize', onResize);

    return () => window.removeEventListener('resize', onResize);
  });

  useEffect(() => {
    if (!reactBodyMovin.current) {
      return;
    }

    const { el } = reactBodyMovin.current;

    ['title', 'role', 'aria-label', 'tabindex'].forEach(entry => {
      el.removeAttribute(entry);
    });

    // console.log(el);
  }, []);

  const EditWrapper = window.dev()
    ? ({ children }) =>
        editWrapperType === 0 ? (
          <EditWrapper0 id={id} selected={selected}>
            {children}
          </EditWrapper0>
        ) : (
          <EditWrapper1 id={id} selected={selected}>
            {children}
          </EditWrapper1>
        )
    : ({ children }) => <_>{children}</_>;

  return (
    <span
      ref={svg}
      css={css`
        width: 100%;
        height: 100%;
        svg {
          max-height: 50vh !important;
        }
      `}
    >
      <EditWrapper>
        {hasAnimationData ? (
          <ReactBodymovin ref={reactBodyMovin} options={bodymovinOptions} />
        ) : (
          ''
        )}
      </EditWrapper>
    </span>
  );
};

export default connect(
  ({ focusedNodeId }: { focusedNodeId: string | number }, { id }: any) => {
    // const { src } = getBlockById(id).props!;
    return {
      focusedNodeId,
      // ...(focusedNodeId === id && { [Math.random()]: '' }),
      // src,
    };
  }
)(SVG);
